<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Mensagens HL7</h4>
            <div class="alert alert-info">
              <i class="bx bx-info-circle me-2"></i>
              Página em desenvolvimento
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Mensagens HL7",
    meta: [{ name: "description", content: "Mensagens HL7" }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Mensagens HL7",
      items: [
        { text: "Integração", href: "/integration" },
        { text: "Mensagens HL7", active: true },
      ],
    };
  },
};
</script>
